<template>
  <SaLandingPage v-if="isSaHost" />
  <HomePage v-else />
</template>

<script lang="ts" setup>
/**
 * Two sites share this route. The South Australia domain proxies straight to this app and its
 * landing page has to answer at `/`, which cannot be an alias because this route owns that
 * path. `v-if` means only the matching branch's setup runs, so the other site's queries never
 * fire, and the host is identical on the server and in the browser so hydration agrees.
 */
const isSaHost = useIsSaHost()
</script>
